import React from 'react'
import { motion } from 'framer-motion'
import heroImage from '../assets/images/hero-image.jpeg'
import { useRouter } from '../hooks/use-router'
import ExpandButton from '../components/shared/ExpandButton'

// Reusable fade-in variant for elements
const fadeInUp = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0 },
}

const YachtSalesPage = () => {
  const router = useRouter()
  return (
    <section className='w-full pb-40'>
      <div
        className='relative bg-cover bg-center h-[500px]'
        style={{
          backgroundImage: `linear-gradient(rgba(23, 37, 84, .4), rgba(23, 37, 84, .4)),url(${heroImage})`,
        }}
      >
        <div className='flex flex-col items-center justify-center h-full text-center text-white w-full'>
          <motion.h1
            initial={{
              y: 15,
              opacity: 0,
            }}
            animate={{
              y: 0,
              opacity: 1,
            }}
            transition={{
              duration: 0.75,
              delay: 0.25,
              ease: 'easeInOut',
            }}
            className='text-4xl font-light mb-2 w-full'
          >
            Yacht Sales
          </motion.h1>
          <div className='w-full flex justify-center my-4'>
            <motion.div
              initial={{ width: '0%' }}
              whileInView={{ width: 200 }}
              transition={{ duration: 0.75, ease: 'easeInOut', delay: 0.5 }}
              className='w-64 h-[2px] origin-center bg-white'
            />
          </div>

          <motion.p
            initial={{
              y: 15,
              opacity: 0,
            }}
            animate={{
              y: 0,
              opacity: 1,
            }}
            transition={{
              duration: 0.75,
              delay: 0.6,
              ease: 'easeInOut',
            }}
            className='text-lg tracking-wide'
          >
            “Yacht Sales The Ethos Way”
          </motion.p>
        </div>
      </div>
      <main className='mx-auto max-w-5xl px-4 py-16 text-center'>
        {/* Page Title */}
        {/* <motion.h1
          className='text-3xl md:text-4xl font-bold mb-6'
          initial='hidden'
          whileInView='visible'
          variants={fadeInUp}
          transition={{ duration: 0.6 }}
          viewport={{ once: true, amount: 0.2 }}
        >
          Smart Yacht Ownership – Your Ultimate Guide to Profitability
        </motion.h1> */}

        {/* Subtitle */}
        {/* <motion.h2
          className='text-brandPrimary text-xl md:text-2xl font-semibold mb-4 uppercase tracking-wide'
          initial='hidden'
          whileInView='visible'
          variants={fadeInUp}
          transition={{ duration: 0.6, delay: 0.1 }}
          viewport={{ once: true, amount: 0.2 }}
        >
          OWNING A YACHT SHOULD BE A SMART INVESTMENT, NOT JUST A LUXURY
        </motion.h2> */}

        {/* Intro Paragraph */}
        <motion.p
          className='text-center text-neutral-500 mt-8 mb-12 leading-relaxed'
          initial='hidden'
          whileInView='visible'
          variants={fadeInUp}
          transition={{ duration: 0.6, delay: 0.2 }}
          viewport={{ once: true, amount: 0.2 }}
        >
          We at Ethos are of the view that purchasing a yacht is not just a
          transaction but rather an initial step towards developing a long-term
          partnership based upon trust, openness, and common interests.
          <br />
          <br />
          As a first-timer or an experienced investor, our job is to take you
          through every step of the process. We don’t merely market yachts — we
          select the correct yacht for you based on goals, budget, and way of
          life to ensure it fits a profitable and sustainable charter business.
          All our recommendations are driven by actual operational knowledge,
          not commission incentives.
          <br />
          <br />
          We carry out rigorous market research, due diligence, and technical
          surveys to ensure that you acquire the best available yacht — one
          which excels on charter, is acknowledged by guests, and is kept to an
          impeccable standard. We are committed above all to safeguarding your
          investment and generating your best possible return, without ever
          compromising safety, quality, or integrity. You'll never be pushed
          into buying. Rather, you'll be counselled honestly, given
          straightforward facts, and dealt with like a partner — that's how
          business is done at Ethos.
        </motion.p>

        <motion.div
          className='flex justify-center'
          initial='hidden'
          whileInView='visible'
          variants={fadeInUp}
          transition={{ duration: 0.6, delay: 0.6 }}
          viewport={{ once: true, amount: 0.2 }}
        >
          <ExpandButton
            buttonText='Contact Us'
            onClick={() => router.push('/contact')}
          />
        </motion.div>
      </main>
    </section>
  )
}

export default YachtSalesPage
